import React from 'react';
import { Button } from './Button';
import { CountdownTimer } from './CountdownTimer';
import { ShieldCheck, Lock, CreditCard, Zap } from 'lucide-react';
export function PurchaseSection() {
  return <section id="compra" className="scroll-mt-10" data-id="element-189">
      {/* Red urgency countdown strip */}
      <div className="bg-red-600 py-4 px-4 text-center border-y-2 border-red-400 shadow-[0_0_30px_rgba(239,68,68,0.3)]" data-id="element-190">
        <p className="text-white font-black text-xs md:text-sm uppercase tracking-widest mb-2 animate-pulse" data-id="element-191">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </p>
        <CountdownTimer className="!text-white [&_div]:!border-white/30 [&_div]:!bg-red-700 [&_span]:!text-white/60 !text-lg md:!text-2xl" data-id="element-192" />
        <p className="text-red-200 font-bold text-xs mt-2 uppercase tracking-wide" data-id="element-193">
          ⚠️ Después sube y no vuelve a bajar
        </p>
        <div className="max-w-xs mx-auto mt-3" data-id="element-194">
          <div className="flex justify-between text-[10px] font-bold mb-1" data-id="element-195">
            <span className="flex items-center text-white" data-id="element-196">
              <span className="w-1.5 h-1.5 rounded-full bg-white mr-1 animate-ping" data-id="element-197"></span>
              Cupos limitados
            </span>
            <span className="text-red-200" data-id="element-198">Quedan pocos</span>
          </div>
          <div className="w-full bg-red-800 rounded-full h-2 overflow-hidden" data-id="element-199">
            <div className="bg-white h-2 rounded-full w-[68%]" data-id="element-200"></div>
          </div>
        </div>
      </div>

      {/* Pricing section */}
      <div className="py-6 md:py-10 px-4 bg-brand-dark" data-id="element-201">
        <div className="max-w-3xl mx-auto" data-id="element-202">
          <div className="text-center mb-6" data-id="element-203">
            <h2 className="text-2xl md:text-3xl font-black text-white uppercase tracking-tight" data-id="element-204">
              Elegí tu Kit
            </h2>
            <p className="text-sm font-bold text-brand-accent neon-glow mt-1" data-id="element-205">
              Las 2 opciones incluyen los 4 bonos
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6" data-id="element-206">
            {/* Basic Kit */}
            <div className="bg-brand-card rounded-xl border border-white/10 p-4 md:p-5 flex flex-col relative" data-id="element-207">
              <h3 className="text-base md:text-lg font-black text-white mb-1 leading-tight" data-id="element-208">
                📘 KIT COMPLETO FUNCIONAL LISTO
              </h3>
              <p className="text-gray-400 font-bold text-xs mb-3" data-id="element-209">
                6 Tomos + 60 clases principiantes + 4 bonos
              </p>
              <div className="flex items-center justify-center gap-2 mb-4 flex-grow" data-id="element-210">
                <span className="text-sm text-gray-500 line-through font-bold" data-id="element-211">
                  USD 35.00
                </span>
                <span className="text-3xl md:text-4xl font-black text-white" data-id="element-212">
                  USD 13.99
                </span>
              </div>
              <Button href="https://kit-online-2026.myshopify.com/cart/44498607341703:1" className="py-2.5 text-sm" pulse={false} data-id="element-213">
                → QUIERO EL KIT
              </Button>
            </div>

            {/* Premium Kit */}
            <div className="bg-brand-card rounded-xl border-2 border-brand-accent p-4 md:p-5 flex flex-col relative shadow-[0_0_20px_rgba(200,255,0,0.15)]" data-id="element-214">
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-brand-accent text-brand-dark font-black px-3 py-0.5 rounded-full text-[10px] tracking-widest shadow-lg whitespace-nowrap uppercase" data-id="element-215">
                ⭐ MÁS ELEGIDO
              </div>
              <h3 className="text-base md:text-lg font-black text-white mb-1 mt-1 leading-tight" data-id="element-216">
                🏆 KIT COMPLETO + SISTEMA PRO
              </h3>
              <p className="text-brand-accent font-bold text-xs mb-3" data-id="element-217">
                6 tomos + 180 clases + Programación + 4 bonos
              </p>
              <div className="flex flex-col items-center justify-center mb-4 flex-grow" data-id="element-218">
                <span className="text-sm text-gray-500 line-through font-bold" data-id="element-219">
                  USD 45.00
                </span>
                <span className="text-3xl md:text-4xl font-black text-brand-accent neon-glow" data-id="element-220">
                  USD 19.90
                </span>
                <span className="bg-brand-accent text-brand-dark font-black text-[10px] px-2 py-0.5 rounded-full uppercase tracking-wider mt-1" data-id="element-221">
                  AHORRÁS USD 25.10
                </span>
              </div>
              <Button href="https://kit-online-2026.myshopify.com/cart/44498607440007:1" className="py-3 text-base shadow-[0_0_20px_rgba(200,255,0,0.4)]" pulse={true} data-id="element-222">
                → QUIERO EL KIT COMPLETO
              </Button>
            </div>
          </div>

          <p className="text-[10px] md:text-xs text-gray-400 text-center mb-4 font-medium leading-snug max-w-lg mx-auto" data-id="element-223">
            El precio es en dólares estadounidenses (USD). El cobro se realiza
            automáticamente en la moneda de tu país al tipo de cambio del
            momento. Pagas en pesos mexicanos, euros, pesos colombianos, soles
            peruanos, pesos chilenos, bolívares, quetzales, lempiras, colones,
            balboas, córdobas o cualquier otra moneda local según su país de
            origen.
          </p>

          <div className="flex flex-wrap justify-center gap-3 text-[10px] md:text-xs text-gray-400 font-bold uppercase tracking-wide" data-id="element-224">
            <div className="flex items-center" data-id="element-225">
              <Lock className="w-3 h-3 mr-1 text-brand-accent" data-id="element-226" />
              <span data-id="element-227">Pago seguro</span>
            </div>
            <div className="flex items-center" data-id="element-228">
              <Zap className="w-3 h-3 mr-1 text-brand-accent" data-id="element-229" />
              <span data-id="element-230">Acceso 5 min</span>
            </div>
            <div className="flex items-center" data-id="element-231">
              <ShieldCheck className="w-3 h-3 mr-1 text-brand-accent" data-id="element-232" />
              <span data-id="element-233">Garantía 7 días</span>
            </div>
            <div className="flex items-center" data-id="element-234">
              <CreditCard className="w-3 h-3 mr-1 text-brand-accent" data-id="element-235" />
              <span data-id="element-236">Tarjeta · Transferencia · Pago local</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}